<template>
	<div class="container__filtragem__content">
		<!-- <v-tabs v-model="model" centered >
                      <v-tab :href="`#tab-1`" > Filtragem </v-tab> 
                  </v-tabs> -->
		<v-tabs-items v-model="model">
			<v-tab-item :value="`tab-1`">
				<div class="container__buttons__tags">
					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.isSingleTrees"
						color="trv-primary"
						label="SingleTrees"
						@click="filtroConfig.isSingleTrees = !filtroConfig.isSingleTrees"
					/>

					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.tiposServicos.includes('001')"
						color="trv-primary"
						label="IFI"
						@click="
							filtroConfig.tiposServicos.includes('001')
								? (filtroConfig.tiposServicos = filtroConfig.tiposServicos.filter(
										(t) => t != '001',
									))
								: filtroConfig.tiposServicos.push('001')
						"
					/>

					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.tiposServicos.includes('002')"
						color="trv-primary"
						label="IFC"
						@click="
							filtroConfig.tiposServicos.includes('002')
								? (filtroConfig.tiposServicos = filtroConfig.tiposServicos.filter(
										(t) => t != '002',
									))
								: filtroConfig.tiposServicos.push('002')
						"
					/>

					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.tiposServicos.includes('003')"
						color="trv-primary"
						label="IPC"
						@click="
							filtroConfig.tiposServicos.includes('003')
								? (filtroConfig.tiposServicos = filtroConfig.tiposServicos.filter(
										(t) => t != '003',
									))
								: filtroConfig.tiposServicos.push('003')
						"
					/>
				</div>
				<!-- Processamento oficial: apenas processamentos oficiais (eifl_is_oficial).
				Base Inativa: apenas fazendas/talhões/plantios inativos. -->
				<div class="container__buttons__tags">
					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.processamentosOficiais"
						color="trv-primary"
						:label="$t('officialProcessing')"
						@click="filtroConfig.processamentosOficiais = !filtroConfig.processamentosOficiais"
					/>

					<Button
						semantic-class="mini"
						:disabled="isCurva || variavelBio"
						:outlined="!filtroConfig.baseInativa"
						color="trv-primary"
						:label="$t('baseInativa')"
						@click="filtroConfig.baseInativa = !filtroConfig.baseInativa"
					/>
				</div>
				<div class="p-4">
					<Switcher
						v-model="filtroConfig.enableHistoricalData"
						:label="$t('habilitarBuscaDadosHistoricos')"
					/>
				</div>
				<div class="container__selecao__campos">
					<DropdownCheckbox
						v-show="true"
						:full-width-list="true"
						:label="$t('fields')"
						:value="valuesDropdownCheckbox"
						:disabled="isCurva || variavelBio"
						lefticon
						icon=""
						@state="whichOneIsChecked"
					/>
				</div>
				<div class="container__campos__filtragem">
					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'fzda').isActive"
						v-model="filtroConfig.fazendasIds"
						:loading="!fazendasOrdenadas.length"
						:disabled="fazendasOrdenadas.length === 0 || isCurva || variavelBio"
						:items="fazendasOrdenadas"
						:label="$t('farms')"
						item-text="nome"
						item-value="id"
						return-object
						multiple
						search
						outlined
						dense
						color="#081f44"
						:filter="customFilter"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<span>{{
									filtroConfig.fazendasIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.fazendasIds.length})`
										: item.nome
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.fazendasIds = filtros.fazendas.concat(filtrosHistoricos.fazenda)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.fazendasIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content color="#081f44">
								<v-list-item-title v-html="item.nome" />
								<v-list-item-subtitle v-html="item.descricao" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'esfl').isActive"
						v-model="filtroConfig.estratosIds"
						:loading="estratosOrdenados.length == 0"
						:disabled="estratosOrdenados.length == 0 || isCurva || variavelBio"
						:items="estratosOrdenados"
						:label="$t('forestStratification')"
						item-text="descricao"
						item-value="id"
						return-object
						outlined
						dense
						multiple
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<span>{{
									filtroConfig.estratosIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.estratosIds.length})`
										: item.descricao
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.estratosIds = filtros.estratos.concat(filtrosHistoricos.estrato)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.estratosIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.descricao" />
								<v-list-item-subtitle v-html="item.fazenda" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<div class="container-selecao-datas first-date">
						<div
							v-show="valuesDropdownCheckbox.find((v) => v.key === 'dtptio').isActive"
							class="container-date-picker"
						>
							<!-- autofill-current-date=false: sao campos de filtro, nao de cadastro.
							     Se o DatePicker preenchesse "hoje" sozinho, a busca sairia sempre com
							     um intervalo de data de plantio que o usuario nao selecionou. -->
							<DatePicker
								v-model="filtroConfig.dataPlantioInicio"
								class="date-picker"
								:placeholder="$t('initialDate')"
								:label="$t('dataDePlantio')"
								:max-date="filtroConfig.dataPlantioFim"
								:autofill-current-date="false"
							/>
							<DatePicker
								v-model="filtroConfig.dataPlantioFim"
								class="date-picker"
								:placeholder="$t('finalDate')"
								:min-date="filtroConfig.dataPlantioInicio"
								:autofill-current-date="false"
							/>
						</div>
					</div>
					<div class="container-selecao-datas second-date">
						<div
							v-show="valuesDropdownCheckbox.find((v) => v.key === 'dtmdco').isActive"
							class="container-date-picker"
						>
							<DatePicker
								v-model="filtroConfig.dataMedicaoInicio"
								class="date-picker"
								:placeholder="$t('initialDate')"
								:label="$t('measurementDate')"
								:max-date="filtroConfig.dataMedicaoFim"
								:autofill-current-date="false"
							/>
							<DatePicker
								v-model="filtroConfig.dataMedicaoFim"
								class="date-picker"
								:placeholder="$t('finalDate')"
								:min-date="filtroConfig.dataMedicaoInicio"
								:autofill-current-date="false"
							/>
						</div>
					</div>

					<div
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'idadeptio').isActive"
						class="idade-plantio-range"
					>
						<span class="idade-plantio-range__label"
							>{{ $t('plantationAge') }} {{ $t('meses') }}</span
						>
						<div class="idade-plantio-range__campos">
							<v-text-field
								v-model.number="filtroConfig.idadePlantioMin"
								type="number"
								min="0"
								step="0.1"
								:disabled="idadesPlantioOrdenadas.length == 0 || isCurva || variavelBio"
								:placeholder="$t('minimo')"
								dense
								outlined
								hide-details
								color="#081f44"
								@input="atualizaIdadesPlantioPorRange"
								@blur="filtroConfig.idadePlantioMin = arredondaIdade(filtroConfig.idadePlantioMin)"
							/>
							<v-text-field
								v-model.number="filtroConfig.idadePlantioMax"
								type="number"
								min="0"
								step="0.1"
								:disabled="idadesPlantioOrdenadas.length == 0 || isCurva || variavelBio"
								:placeholder="$t('maximo')"
								dense
								outlined
								hide-details
								color="#081f44"
								@input="atualizaIdadesPlantioPorRange"
								@blur="filtroConfig.idadePlantioMax = arredondaIdade(filtroConfig.idadePlantioMax)"
							/>
						</div>
					</div>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'spcmt').isActive"
						v-model="filtroConfig.espacamentos"
						:loading="espacamentosOrdenados.length == 0"
						:disabled="espacamentosOrdenados.length == 0 || isCurva || variavelBio"
						:items="espacamentosOrdenados"
						:label="$t('spacing')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						search
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.espacamentos.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.espacamentos.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.espacamentos = filtros.espacamentos.concat(
											filtrosHistoricos.espacamento,
										)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.espacamentos = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>
					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'spce').isActive"
						v-model="filtroConfig.especiesIds"
						:loading="especiesOrdenadas.length == 0"
						:disabled="especiesOrdenadas.length == 0 || isCurva || variavelBio"
						:items="especiesOrdenadas"
						:label="$t('species')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						search
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.descricao }}</span> -->
								<span>{{
									filtroConfig.especiesIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.especiesIds.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.especiesIds = filtros.especies.concat(filtrosHistoricos.especie)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.especiesIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'matgen').isActive"
						v-model="filtroConfig.materiaisGeneticos"
						:loading="materiaisGeneticosOrdenados == 0"
						:disabled="materiaisGeneticosOrdenados == 0 || isCurva || variavelBio"
						:items="materiaisGeneticosOrdenados"
						:label="$t('geneticMaterial')"
						item-text="label"
						item-value="value"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.materiaisGeneticos.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.materiaisGeneticos.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.materiaisGeneticos = filtros.materiaisGeneticos.concat(
											filtrosHistoricos.materialGenetico,
										)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.materiaisGeneticos = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'tlho')?.isActive"
						v-model="filtroConfig.talhoesIds"
						:loading="talhoesOrdenados.length === 0"
						:disabled="talhoesOrdenados.length === 0 || isCurva || variavelBio"
						:items="talhoesOrdenados"
						:label="$t('section')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.talhoesIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.talhoesIds.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.talhoesIds = filtrosHistoricos.talhao.concat(filtros.talhoes)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.talhoesIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'ptio')?.isActive"
						v-model="filtroConfig.plantiosIds"
						:loading="plantiosOrdenados.length === 0"
						:disabled="plantiosOrdenados.length === 0 || isCurva || variavelBio"
						:items="plantiosOrdenados"
						:label="$t('plantation')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.plantiosIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.plantiosIds.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.plantiosIds = filtrosHistoricos.plantio.concat(filtros.plantios)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.plantiosIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'prcl')?.isActive"
						v-model="filtroConfig.parcelasIds"
						:loading="parcelasOrdenados.length === 0"
						:disabled="parcelasOrdenados.length === 0 || isCurva || variavelBio"
						:items="parcelasOrdenados"
						:label="$t('plot')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.parcelasIds.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.parcelasIds.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.parcelasIds = filtrosHistoricos.parcela.concat(filtros.parcelas)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.parcelasIds = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'cidade')?.isActive"
						v-model="filtroConfig.cidades"
						:loading="cidadesOrdenados.length === 0"
						:disabled="cidadesOrdenados.length === 0 || isCurva || variavelBio"
						:items="cidadesOrdenados"
						:label="$t('city')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.cidades.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.cidades.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="filtroConfig.cidades = filtrosHistoricos.cidade.concat(filtros.cidades)"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.cidades = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'estado')?.isActive"
						v-model="filtroConfig.estados"
						:loading="estadosOrdenados.length === 0"
						:disabled="estadosOrdenados.length === 0 || isCurva || variavelBio"
						:items="estadosOrdenados"
						:label="$t('state')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.estados.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.estados.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip @click="filtroConfig.estados = filtrosHistoricos.estado">
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.estados = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'pais')?.isActive"
						v-model="filtroConfig.paises"
						:loading="paisesOrdenados.length === 0"
						:disabled="paisesOrdenados.length === 0 || isCurva || variavelBio"
						:items="paisesOrdenados"
						:label="$t('country')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.paises.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.paises.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="filtroConfig.paises = filtrosHistoricos.pais.concat(filtros.paises)"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.paises = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'manejo')?.isActive"
						v-model="filtroConfig.manejos"
						:loading="manejosOrdenados.length === 0"
						:disabled="manejosOrdenados.length === 0 || isCurva || variavelBio"
						:items="manejosOrdenados"
						:label="$t('management')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.manejos.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.manejos.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="filtroConfig.manejos = filtrosHistoricos.manejo.concat(filtros.manejos)"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.manejos = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'ciclo')?.isActive"
						v-model="filtroConfig.ciclos"
						:loading="ciclosOrdenados.length === 0"
						:disabled="ciclosOrdenados.length === 0 || isCurva || variavelBio"
						:items="ciclosOrdenados"
						:label="$t('cicle')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.ciclos.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.ciclos.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="filtroConfig.ciclos = filtrosHistoricos.ciclo.concat(filtros.ciclos)"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.ciclos = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'rotacao')?.isActive"
						v-model="filtroConfig.rotacoes"
						:loading="rotacoesOrdenados.length === 0"
						:disabled="rotacoesOrdenados.length === 0 || isCurva || variavelBio"
						:items="rotacoesOrdenadas"
						:label="$t('rotation')"
						item-text="label"
						item-value="id"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.rotacoes.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.rotacoes.length})`
										: item.label
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.rotacoes = filtrosHistoricos.rotacao.concat(filtros.rotacoes)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.rotacoes = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.label" />
							</v-list-item-content>
						</template>
					</v-autocomplete>

					<v-autocomplete
						v-show="valuesDropdownCheckbox.find((v) => v.key === 'variaveisCustomizadas')?.isActive"
						v-model="filtroConfig.variaveis"
						:loading="filtros.variaveis.length === 0"
						:disabled="filtros.variaveis.length === 0 || isCurva || variavelBio"
						:items="variaveisOrdenadas"
						:label="$t('customVariables')"
						item-text="label"
						item-value="value"
						return-object
						multiple
						dense
						outlined
						color="#081f44"
					>
						<template #selection="{ item, index }">
							<v-chip
								v-if="index === 0"
								small
							>
								<!-- <span>{{ item.label }}</span> -->
								<span>{{
									filtroConfig.variaveis.length > 1
										? `${$t('multiSelect')}
                  (${filtroConfig.variaveis.length})`
										: item.value
								}}</span>
							</v-chip>
						</template>
						<template #prepend-item>
							<div style="display: flex; flex-direction: row; justify-content: space-evenly">
								<v-chip
									@click="
										filtroConfig.variaveis = filtrosHistoricos.variaveis.concat(filtros.variaveis)
									"
								>
									{{ $t('selectAll') }}
								</v-chip>
								<v-chip @click="filtroConfig.variaveis = []">
									{{ $t('clearSelected') }}
								</v-chip>
							</div>
						</template>
						<template #item="{ item }">
							<v-list-item-content>
								<v-list-item-title v-html="item.value" />
							</v-list-item-content>
						</template>
					</v-autocomplete>
				</div>
			</v-tab-item>
			<v-tab-item :value="`tab-2`">
				<v-card flat>
					<v-card-text v-text="'variaveis'" />
				</v-card>
			</v-tab-item>
		</v-tabs-items>
		<div class="container__action__buttons">
			<div style="display: flex; gap: 0.5rem">
				<Button
					:label="$t('searchClusters')"
					:disabled="isCurva || variavelBio"
					:loading="fetchAgrupamentos"
					:key="`buscar-${fetchAgrupamentos}`"
					color="trv-primary"
					@click="sendFilters()"
				/>

				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<div
							v-bind="attrs"
							v-on="on"
						>
							<Button
								icon="fas fa-backspace"
								:disabled="isCurva || variavelBio"
								color="trv-primary"
								@click="limparFiltros()"
							/>
						</div>
					</template>
					<span>{{ $t('clearFilters') }}</span>
				</v-tooltip>
			</div>
			<div class="container__buttons">
				<Button
					:label="$t('back')"
					:disabled="fetchAgrupamentos || loading"
					color="trv-primary"
					outlined
					@click="voltar"
				/>
				<Button
					:loading="loading || processandoJob"
					:label="$t('process')"
					:disabled="isProcessAvailable || fetchAgrupamentos || processandoJob"
					color="trv-secondary"
					@click="escolhaModelos"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import DropdownCheckbox from '../../../components/DropdownCheckbox/DropdownCheckbox'
import Switcher from '../../../components/Switcher/Switcher'

import {
	filterParcelas,
	getFiltrosDropdown,
	recuperarInformacoesHistoricasParaDropdows,
} from '../../../services/requests/ClassificacaoSitioRequests'
import { filterParcelasPrognose } from '../../../services/requests/PrognoseRequests'
import DatePicker from '../../../components/DatePicker/DatePicker.vue'

export default {
	components: {
		// DropdownFk,
		// Dropdown,
		Button,
		Switcher,
		DropdownCheckbox,
		DatePicker,
	},
	props: {
		isCurva: { type: Boolean, default: false },
		variavelBio: { type: Boolean, default: false },
		isPrognose: { type: Boolean, default: false },
		// Variável do eixo Y do gráfico de dispersão (vem do pai). Quando definida, a
		// busca pede ao back a redução IQR só para visualização (≤ maxPontosGrafico
		// pontos + flag de outlier), evitando trazer 100k+ pro browser.
		variavelGrafico: { type: String, default: '' },
		maxPontosGrafico: { type: Number, default: 10000 },
		setLoading: Boolean,
		setColor: String,
		disableValue: Boolean,
		value: Object,
		test: {
			type: String,
			require: true,
		},

		test2: {
			type: String,
			require: true,
		},

		estaApenasVisualizandoOResultado: { type: Boolean, default: false },
		// Há um job de processamento em andamento (inclusive retomado via central):
		// desabilita o Processar para não enfileirar um duplicado.
		processandoJob: { type: Boolean, default: false },
	},
	data() {
		return {
			loader: null,
			loading: false,
			fetchAgrupamentos: false,
			color: 'trv-default',
			disableBuscar: false,
			estratos: [],
			filtrosHistoricos: {},
			filtros: {
				fazendas: [],
				estratos: [],
				datasMedicao: [],
				datasPlantio: [],
				rangeDatasPlantio: [],
				rangeDatasMedicao: [],
				idadesPlantio: [],
				espacamentos: [],
				especies: [],
				talhoes: [],
				plantios: [],
				parcelas: [],
				cidades: [],
				paises: [],
				manejos: [],
				ciclos: [],
				rotacoes: [],
				variaveis: [],
				materiaisGeneticos: [],
				dataPlantioMaxMin: [],
				dataMedicaoMaxMin: [],
			},
			// tempoFiltragem: {},
			isProcessAvailable: true,
			filtroConfig: {
				estratosIds: [],
				datasMedicao: [],
				datasPlantio: [],
				selectedDataPlantio: [],
				selectedIdadePlantio: [],
				dataPlantioInicio: '',
				dataPlantioFim: '',
				dataMedicaoInicio: '',
				dataMedicaoFim: '',
				IntervaloDataMedicaoSlider: [],
				IntervaloDataSlider: [],
				tiposServicos: [],
				// idadesPlantio continua sendo a fonte para a busca/processar/histórico;
				// agora é DERIVADO do range (inicial/final), não mais de um dropdown.
				idadesPlantio: [],
				idadePlantioMin: null,
				idadePlantioMax: null,
				materiaisGeneticos: [],
				especiesIds: [],
				fazendasIds: [],
				espacamentos: [],
				talhoesIds: [],
				plantiosIds: [],
				parcelasIds: [],
				cidades: [],
				estados: [],
				paises: [],
				manejos: [],
				ciclos: [],
				rotacoes: [],
				variaveis: [],
				isSingleTrees: false,
				processamentosOficiais: false,
				baseInativa: false,
				enableHistoricalData: false,
			},
			model: 'tab-1',
			valuesDropdownCheckbox: [
				{
					key: 'fzda',
					value: this.$t('farm'),
					isActive: true,
				},
				{
					key: 'esfl',
					value: this.$t('forestStratification'),
					isActive: true,
				},
				{
					key: 'dtptio',
					value: this.$t('plantationDate'),
					isActive: true,
				},
				{
					key: 'dtmdco',
					value: this.$t('measurementDate'),
					isActive: true,
				},
				{
					key: 'idadeptio',
					value: this.$t('plantationAge'),
					isActive: false,
				},
				{
					key: 'spcmt',
					value: this.$t('spacing'),
					isActive: true,
				},
				{
					key: 'spce',
					value: this.$t('species'),
					isActive: false,
				},

				{
					key: 'matgen',
					value: this.$t('geneticMaterial'),
					isActive: true,
				},
				{
					key: 'tlho',
					value: this.$t('section'),
					isActive: false,
				},
				{
					key: 'ptio',
					value: this.$t('plantation'),
					isActive: false,
				},
				{
					key: 'prcl',
					value: this.$t('plot'),
					isActive: false,
				},
				{
					key: 'cidade',
					value: this.$t('city'),
					isActive: false,
				},
				{
					key: 'estado',
					value: this.$t('state'),
					isActive: false,
				},
				{
					key: 'pais',
					value: this.$t('country'),
					isActive: false,
				},
				{
					key: 'manejo',
					value: this.$t('management'),
					isActive: false,
				},
				{
					key: 'ciclo',
					value: this.$t('cicle'),
					isActive: false,
				},
				{
					key: 'rotacao',
					value: this.$t('rotation'),
					isActive: false,
				},
				{
					key: 'variaveisCustomizadas',
					value: this.$t('customizedVariables'),
					isActive: false,
				},
			],
		}
	},
	computed: {
		rootStyle() {
			return {
				['--color-green']: getComputedStyle(document.documentElement)
					.getPropertyValue('--color-green')
					.trim(),
				['--color-success-background']: getComputedStyle(document.documentElement)
					.getPropertyValue('--color-success-background')
					.trim(),
			}
		},

		existeAlgumFiltroConfigurado() {
			if (this.value) {
				const exisateCiclos = this.value.ciclos.length != 0
				const exisateCidades = this.value.cidades.length != 0
				const exisateDatasMedicao = this.value.datasMedicao.length != 0
				const exisateDatasPlantio = this.value.datasPlantio.length != 0
				const exisateEnableHistoricalData = this.value.enableHistoricalData.length != 0
				const exisateEspacamentos = this.value.espacamentos.length != 0
				const exisateEspeciesIds = this.value.especiesIds.length != 0
				const exisateEstados = this.value.estados.length != 0
				const exisateEstratosIds = this.value.estratosIds.length != 0
				const exisateFazendasIds = this.value.fazendasIds.length != 0
				const exisateIdadesPlantio = this.value.idadesPlantio.length != 0
				const exisateIsSingleTrees = this.value.isSingleTrees == true
				const exisateProcessamentosOficiais = this.value.processamentosOficiais == true
				const exisateBaseInativa = this.value.baseInativa == true
				const exisateManejos = this.value.manejos.length != 0
				const exisateMateriaisGeneticos = this.value.materiaisGeneticos.length != 0
				const exisatePaises = this.value.paises.length != 0
				const exisateParcelasIds = this.value.parcelasIds.length != 0
				const exisatePlantiosIds = this.value.plantiosIds.length != 0
				const exisateRotacoes = this.value.rotacoes.length != 0
				const exisateSelectedDataPlantio = this.value.selectedDataPlantio.length != 0
				const exisateSelectedIdadePlantio = this.value.selectedIdadePlantio.length != 0
				const exisateTalhoesIds = this.value.talhoesIds.length != 0
				const exisateTiposServicos = this.value.tiposServicos.length != 0
				const exisateVariaveis = this.value.variaveis.length != 0

				return (
					exisateCiclos ||
					exisateCidades ||
					exisateDatasMedicao ||
					exisateDatasPlantio ||
					exisateEnableHistoricalData ||
					exisateEspacamentos ||
					exisateEspeciesIds ||
					exisateEstados ||
					exisateEstratosIds ||
					exisateFazendasIds ||
					exisateIdadesPlantio ||
					exisateIsSingleTrees ||
					exisateProcessamentosOficiais ||
					exisateBaseInativa ||
					exisateManejos ||
					exisateMateriaisGeneticos ||
					exisatePaises ||
					exisateParcelasIds ||
					exisatePlantiosIds ||
					exisateRotacoes ||
					exisateSelectedDataPlantio ||
					exisateSelectedIdadePlantio ||
					exisateTalhoesIds ||
					exisateTiposServicos ||
					exisateVariaveis
				)
			}
			return false
		},

		variaveisOrdenadas() {
			let variaveisCustomizadas = this.filtros.variaveis.flatMap((filtro) => {
				return filtro.variaveis.map((variavel) => {
					return {
						// name: variavel.name,
						value: variavel.name + ' ' + variavel.value,
					}
				})
			})
			return variaveisCustomizadas
		},

		//! Opção que retorna exclusivamente medições históricas
		rotacoesOrdenados() {
			let selected = [],
				notSelected = []
			let rotacoes =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.rotacao
					? this.filtrosHistoricos.rotacao
							.map((rotacao) => {
								return { ...rotacao, descricao: rotacao.label }
							})
							.concat(this.filtros.rotacoes)
					: this.filtros.rotacoes

			rotacoes = this.removeDuplicates(rotacoes, 'label')
			rotacoes = rotacoes.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = rotacoes.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "-1" quando é de tipo numérico
			if (nao_definido) {
				rotacoes.splice(rotacoes.indexOf(nao_definido), 1, { ...nao_definido, value: -1 })
			}

			selected = rotacoes.filter((f) => this.filtroConfig.rotacoes.map((m) => m.id).includes(f.id))
			notSelected = rotacoes.filter(
				(f) => !this.filtroConfig.rotacoes.map((m) => m.id).includes(f.id),
			)

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		ciclosOrdenados() {
			let selected = [],
				notSelected = []

			let ciclos =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.ciclo
					? this.filtrosHistoricos.ciclo
							.map((ciclo) => {
								return { ...ciclo, descricao: ciclo.label }
							})
							.concat(this.filtros.ciclos.filter((f) => f.ciclo))
					: this.filtros.ciclos.filter((f) => f.ciclo)
			ciclos = this.removeDuplicates(ciclos, 'label')
			ciclos = ciclos.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = ciclos.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "-1" quando é de tipo numérico
			if (nao_definido) {
				ciclos.splice(ciclos.indexOf(nao_definido), 1, { ...nao_definido, value: -1 })
			}

			selected = ciclos.filter((f) => this.filtroConfig.ciclos.map((m) => m.id).includes(f.id))
			notSelected = ciclos.filter((f) => !this.filtroConfig.ciclos.map((m) => m.id).includes(f.id))

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		manejosOrdenados() {
			let selected = [],
				notSelected = []

			let manejos =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.manejo
					? this.filtrosHistoricos.manejo
							.map((manejo) => {
								return { ...manejo, descricao: manejo.label }
							})
							.concat(this.filtros.manejos.filter((f) => f.manejo))
					: this.filtros.manejos.filter((f) => f.manejo)

			manejos = this.removeDuplicates(manejos, 'label')
			manejos = manejos.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = manejos.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				manejos.splice(manejos.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			selected = manejos.filter((f) => this.filtroConfig.manejos.map((m) => m.id).includes(f.id))
			notSelected = manejos.filter(
				(f) => !this.filtroConfig.manejos.map((m) => m.id).includes(f.id),
			)

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		paisesOrdenados() {
			let selected = [],
				notSelected = []

			let paises =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.pais
					? this.filtrosHistoricos.pais
							.map((pais) => {
								return { ...pais, descricao: pais.label }
							})
							.concat(this.filtros.paises)
					: this.filtros.paises
			paises = this.removeDuplicates(paises, 'label')
			paises = paises.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = paises.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				paises.splice(paises.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			selected = paises.filter((f) => this.filtroConfig.paises.map((m) => m.id).includes(f.id))
			notSelected = paises.filter((f) => !this.filtroConfig.paises.map((m) => m.id).includes(f.id))

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		estadosOrdenados() {
			let selected = [],
				notSelected = []

			if (this.filtrosHistoricos.estado) {
				const estados = this.filtrosHistoricos.estado.map((rotacao) => {
					return {
						...rotacao,
						value: rotacao.label,
					}
				})

				const nao_definido = estados.find((f) => f.label === 'Não definido')

				//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
				if (nao_definido) {
					estados.splice(estados.indexOf(nao_definido), 1, {
						...nao_definido,
						value: '@campo_nao_preenchido@',
					})
				}

				selected = estados.filter((f) => this.filtroConfig.estados.map((m) => m.id).includes(f.id))
				notSelected = estados.filter(
					(f) => !this.filtroConfig.estados.map((m) => m.id).includes(f.id),
				)
			}

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		cidadesOrdenados() {
			let selected = [],
				notSelected = []

			let cidades =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.cidade
					? this.filtrosHistoricos.cidade
							.map((cidade) => {
								return { ...cidade, descricao: cidade.label }
							})
							.concat(this.filtros.cidades)
					: this.filtros.cidades
			cidades = this.removeDuplicates(cidades, 'label')
			cidades = cidades.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = cidades.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				cidades.splice(cidades.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			selected = cidades.filter((f) => this.filtroConfig.cidades.map((m) => m.id).includes(f.id))
			notSelected = cidades.filter(
				(f) => !this.filtroConfig.cidades.map((m) => m.id).includes(f.id),
			)

			return [...selected, ...notSelected]
		},
		//! Opção que retorna exclusivamente medições históricas
		parcelasOrdenados() {
			let selected = [],
				notSelected = []

			let parcelas =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.parcela
					? this.filtrosHistoricos.parcela
							.map((parcela) => {
								return { ...parcela, descricao: parcela.label }
							})
							.concat(this.filtros.parcelas)
					: this.filtros.parcelas
			parcelas = this.removeDuplicates(parcelas, 'label')

			parcelas = parcelas.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id,
				}
			})

			const nao_definido = parcelas.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" (UUID vazio) quando é de tipo UUID
			if (nao_definido) {
				parcelas.splice(parcelas.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			selected = parcelas.filter((talhao) =>
				this.filtroConfig.parcelasIds.map((m) => m.id).includes(talhao.id),
			)
			notSelected = parcelas.filter(
				(talhao) => !this.filtroConfig.parcelasIds.map((m) => m.id).includes(talhao.id),
			)

			return [...selected, ...notSelected]
		},

		//! Opção que retorna exclusivamente medições históricas
		talhoesOrdenados() {
			let selected = [],
				notSelected = []

			let talhoes =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.talhao
					? this.filtrosHistoricos.talhao
							.map((talhao) => {
								return { ...talhao, descricao: talhao.label }
							})
							.concat(this.filtros.talhoes)
					: this.filtros.talhoes
			talhoes = this.removeDuplicates(talhoes, 'label')
			talhoes = talhoes.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id,
				}
			})

			const nao_definido = talhoes.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" (UUID vazio) quando é de tipo UUID
			if (nao_definido) {
				talhoes.splice(talhoes.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			selected = talhoes.filter((talhao) =>
				this.filtroConfig.talhoesIds.map((m) => m.id).includes(talhao.id),
			)
			notSelected = talhoes.filter(
				(talhao) => !this.filtroConfig.talhoesIds.map((m) => m.id).includes(talhao.id),
			)

			return [...selected, ...notSelected]
		},

		//! Opção que retorna exclusivamente medições históricas
		plantiosOrdenados() {
			let selected = [],
				notSelected = []

			let plantios =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.plantio
					? this.filtrosHistoricos.plantio
							.map((plantio) => {
								return { ...plantio, descricao: plantio.label }
							})
							.concat(this.filtros.plantios)
					: this.filtros.plantios
			plantios = this.removeDuplicates(plantios, 'label')
			plantios = plantios.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id,
				}
			})

			const nao_definido = plantios.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" (UUID vazio) quando é de tipo UUID
			if (nao_definido) {
				plantios.splice(plantios.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			selected = plantios.filter((talhao) =>
				this.filtroConfig.plantiosIds.map((m) => m.id).includes(talhao.id),
			)
			notSelected = plantios.filter(
				(talhao) => !this.filtroConfig.plantiosIds.map((m) => m.id).includes(talhao.id),
			)

			return [...selected, ...notSelected]
		},

		estratosOrdenados() {
			//! Adaptação para funcionar com dados históricos
			let estratos = this.filtros.estratos
			// filtro em cascata so funciona para NAO dados históricos
			if (this.filtroConfig.fazendasIds.length > 0) {
				estratos = estratos.filter((estrato) =>
					this.filtroConfig.fazendasIds.map((fazenda) => fazenda.id).includes(estrato.fazenda_Id),
				)
			}
			// se dados historicos estiverem habilitados, concatena os estratos históricos com os atuais
			if (this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.estrato) {
				estratos = this.filtrosHistoricos.estrato
					.map((estrato) => {
						return { ...estrato, descricao: estrato.label.concat(this.$t('dadoshistoricos')) }
					})
					.concat(estratos)
			}

			estratos = estratos.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id,
				}
			})

			const nao_definido = estratos.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" (UUID vazio) quando é de tipo UUID
			if (nao_definido) {
				estratos.splice(estratos.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			let selected = estratos.filter((f) =>
				this.filtroConfig.estratosIds.map((i) => i.id).includes(f.id),
			)
			let notSelected = estratos.filter(
				(f) => !this.filtroConfig.estratosIds.map((i) => i.id).includes(f.id),
			)
			return [...selected, ...notSelected]
		},

		fazendasOrdenadas() {
			//! Adaptação para funcionar com dados históricos
			let fazendas =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.fazenda
					? this.filtrosHistoricos.fazenda
							.map((fazenda) => {
								return { ...fazenda, nome: fazenda.label }
							})
							.concat(this.filtros.fazendas)
					: this.filtros.fazendas

			fazendas = fazendas.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id,
				}
			})

			const nao_definido = fazendas.find((f) => f.nome === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" (UUID vazio) quando é de tipo UUID
			if (nao_definido) {
				fazendas.splice(fazendas.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			let selected = fazendas.filter((f) =>
				this.filtroConfig.fazendasIds.map((i) => i.id).includes(f.id),
			)

			let notSelected = fazendas.filter(
				(f) => !this.filtroConfig.fazendasIds.map((i) => i.id).includes(f.id),
			)
			return [...selected, ...notSelected]
		},

		datasMedicoesOrdenadas() {
			//! Adaptação para funcionar com dados históricos
			let datasMedicoes =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.dataMedicao
					? this.filtrosHistoricos.dataMedicao.concat(this.filtros.datasMedicao)
					: this.filtros.datasMedicao
			datasMedicoes = datasMedicoes.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = datasMedicoes.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				datasMedicoes.splice(datasMedicoes.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			let selected = datasMedicoes.filter((f) =>
				this.filtroConfig.datasMedicao.map((i) => i.id).includes(f.id),
			)
			let notSelected = datasMedicoes.filter(
				(f) => !this.filtroConfig.datasMedicao.map((i) => i.id).includes(f.id),
			)

			return [...selected, ...notSelected]
		},

		datasPlantioOrdenadas() {
			//! Adaptação para funcionar com dados históricos
			let datasPlantios =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.dataPlantio
					? this.filtrosHistoricos.dataPlantio.concat(this.filtros.datasPlantio)
					: this.filtros.datasPlantio
			datasPlantios = datasPlantios.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = datasPlantios.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				datasPlantios.splice(datasPlantios.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			let selected = datasPlantios.filter((f) =>
				this.filtroConfig.datasPlantio.map((i) => i.value).includes(f.value),
			)
			let notSelected = datasPlantios.filter(
				(f) => !this.filtroConfig.datasPlantio.map((i) => i.value).includes(f.value),
			)
			return [...selected, ...notSelected]
		},

		idadesPlantioOrdenadas() {
			//! Adaptação para funcionar com dados históricos
			let idades =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.idade
					? this.filtrosHistoricos.idade.concat(this.filtros.idadesPlantio)
					: this.filtros.idadesPlantio
			idades = this.removeDuplicates(idades, 'label')
			idades = idades.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})

			const nao_definido = idades.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave -1 quando é de tipo texto
			if (nao_definido) {
				idades.splice(idades.indexOf(nao_definido), 1, { ...nao_definido, value: -1 })
			}

			let selected = idades.filter((f) =>
				this.filtroConfig.idadesPlantio.map((i) => i.value).includes(f.value),
			)
			let notSelected = idades.filter(
				(f) => !this.filtroConfig.idadesPlantio.map((i) => i.value).includes(f.value),
			)
			return [...selected, ...notSelected]
		},

		espacamentosOrdenados() {
			//! Adaptação para funcionar com dados históricos
			let espacamentos =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.espacamento
					? this.filtrosHistoricos.espacamento.concat(this.filtros.espacamentos)
					: this.filtros.espacamentos
			espacamentos = this.removeDuplicates(espacamentos, 'label')
			espacamentos = espacamentos.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.label,
				}
			})
			const nao_definido = espacamentos.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "@campo_nao_preenchido@" quando é de tipo texto
			if (nao_definido) {
				espacamentos.splice(espacamentos.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '@campo_nao_preenchido@',
				})
			}

			let selected = espacamentos.filter((f) =>
				this.filtroConfig.espacamentos.map((i) => i.value).includes(f.value),
			)
			let notSelected = espacamentos.filter(
				(f) => !this.filtroConfig.espacamentos.map((i) => i.value).includes(f.value),
			)
			return [...selected, ...notSelected]
		},

		especiesOrdenadas() {
			//! Adaptação para funcionar com dados históricos
			let especies =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.especie
					? this.filtrosHistoricos.especie
							.map((especie) => {
								return { ...especie, value: especie.id }
							})
							.concat(this.filtros.especies)
					: this.filtros.especies
			especies = this.removeDuplicates(especies, 'label')
			especies = especies.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id || rotacao.value,
				}
			})

			const nao_definido = especies.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" quando é de tipo texto
			if (nao_definido) {
				especies.splice(especies.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			let selected = especies.filter((f) =>
				this.filtroConfig.especiesIds.map((i) => i.id).includes(f.id),
			)
			let notSelected = especies.filter(
				(f) => !this.filtroConfig.especiesIds.map((i) => i.id).includes(f.id),
			)
			return [...selected, ...notSelected]
		},

		materiaisGeneticosOrdenados() {
			//! Adaptação para funcionar com dados históricos
			let materiaisGeneticos =
				this.filtroConfig.enableHistoricalData && this.filtrosHistoricos.materialGenetico
					? this.filtrosHistoricos.materialGenetico
							.map((material) => {
								return { ...material, value: material.id }
							})
							.concat(this.filtros.materiaisGeneticos)
					: this.filtros.materiaisGeneticos
			materiaisGeneticos = this.removeDuplicates(materiaisGeneticos, 'label')
			materiaisGeneticos = materiaisGeneticos.map((rotacao) => {
				return {
					...rotacao,
					value: rotacao.id || rotacao.value,
				}
			})

			const nao_definido = materiaisGeneticos.find((f) => f.label === 'Não definido')

			//campos que nao foram mapeados na importação sao filtrados pela palavra chave "00000000-0000-0000-0000-000000000000" quando é de tipo texto
			if (nao_definido) {
				materiaisGeneticos.splice(materiaisGeneticos.indexOf(nao_definido), 1, {
					...nao_definido,
					value: '00000000-0000-0000-0000-000000000000',
				})
			}

			let selected = materiaisGeneticos.filter((f) =>
				this.filtroConfig.materiaisGeneticos.map((i) => i.value).includes(f.value),
			)

			let notSelected = materiaisGeneticos.filter(
				(f) => !this.filtroConfig.materiaisGeneticos.map((i) => i.value).includes(f.value),
			)

			return [...selected, ...notSelected]
		},
	},
	watch: {
		value() {
			this.filtroConfig = {
				estratosIds: this.value.estratosIds,
				datasMedicao: this.convertToFormattedDates(this.value.IntervaloDataMedicaoSlider),
				datasPlantio: this.convertToFormattedDates(this.value.IntervaloDataSlider),
				IntervaloDataMedicaoSlider: this.value.IntervaloDataMedicaoSlider,
				IntervaloDataSlider: this.value.IntervaloDataSlider,
				selectedDataPlantio: this.value.selectedDataPlantio,
				dataPlantioInicio:
					this.value.IntervaloDataSlider &&
					this.value.IntervaloDataSlider[0] !== null &&
					this.value.IntervaloDataSlider[0] !== undefined &&
					this.value.IntervaloDataSlider[0] !== 0
						? new Date(this.value.IntervaloDataSlider[0])
						: '',
				dataPlantioFim:
					this.value.IntervaloDataSlider &&
					this.value.IntervaloDataSlider[1] !== null &&
					this.value.IntervaloDataSlider[1] !== undefined &&
					this.value.IntervaloDataSlider[1] !== 0
						? new Date(this.value.IntervaloDataSlider[1])
						: '',

				// Valida o indice [0], que e o que se le. Validar [1] aqui (como antes)
				// fazia um filtro salvo como [null, dataFim] passar na condicao e cair em
				// new Date(null) => 01/01/1970 como data inicial ao reabrir para editar.
				dataMedicaoInicio:
					this.value.IntervaloDataMedicaoSlider &&
					this.value.IntervaloDataMedicaoSlider[0] !== null &&
					this.value.IntervaloDataMedicaoSlider[0] !== undefined &&
					this.value.IntervaloDataMedicaoSlider[0] !== 0
						? new Date(this.value.IntervaloDataMedicaoSlider[0])
						: '',
				dataMedicaoFim:
					this.value.IntervaloDataMedicaoSlider &&
					this.value.IntervaloDataMedicaoSlider[1] !== null &&
					this.value.IntervaloDataMedicaoSlider[1] !== undefined &&
					this.value.IntervaloDataMedicaoSlider[1] !== 0
						? new Date(this.value.IntervaloDataMedicaoSlider[1])
						: '',
				tiposServicos: this.value.tiposServicos,
				idadesPlantio: this.value.idadesPlantio,
				// Range da idade: dos campos salvos (filtros novos) ou derivado do
				// min/max de idadesPlantio (retrocompat com filtros salvos antigos).
				idadePlantioMin:
					this.value.idadePlantioMin ?? this.derivaRangeIdade(this.value.idadesPlantio).min,
				idadePlantioMax:
					this.value.idadePlantioMax ?? this.derivaRangeIdade(this.value.idadesPlantio).max,
				materiaisGeneticos: this.value.materiaisGeneticos,
				especiesIds: this.value.especiesIds,
				fazendasIds: this.value.fazendasIds,
				espacamentos: this.value.espacamentos,
				talhoesIds: this.value.talhoesIds,
				plantiosIds: this.value.plantiosIds,
				parcelasIds: this.value.parcelasIds,
				cidades: this.value.cidades,
				estados: this.value.estados,
				paises: this.value.paises,
				manejos: this.value.manejos,
				ciclos: this.value.ciclos,
				rotacoes: this.value.rotacoes,
				variaveis: this.value.variaveis,
				isSingleTrees: this.value.isSingleTrees,
				processamentosOficiais: this.value.processamentosOficiais ?? false,
				baseInativa: this.value.baseInativa ?? false,
				enableHistoricalData: this.value.enableHistoricalData,
			}
		},
		setLoading() {
			if (this.setLoading == true) {
				this.loading = false
			}
		},
		setColor() {
			if (this.setColor == 'gray') {
				this.color = 'trv-default'
			}
		},
		loader() {
			const l = this.loader
			this[l] = !this[l]

			setTimeout(() => (this[l] = false), 3000)

			this.loader = null
		},

		filtroConfig: {
			async handler() {
				this.$emit('filtroConfig', this.filtroConfig)
			},
			deep: true,
			immediate: true,
		},
	},
	async created() {
		// As duas cargas são independentes — em paralelo em vez de sequencial.
		const [filtros, filtroHistorico] = await Promise.all([
			getFiltrosDropdown(),
			recuperarInformacoesHistoricasParaDropdows(),
		])
		// Object.freeze: os dropdowns trazem as listas do acervo inteiro (talhões,
		// plantios, parcelas, medições históricas). Sem congelar, o Vue 2 torna cada
		// item reativo (getter/setter + Dep recursivo) e estoura a memoria em acervos
		// grandes — "out of memory" ja no carregar dos filtros. Congelado, o Vue pula
		// a observacao (sao so dados lidos pelos computed; nunca reescritos aqui).
		this.filtros = Object.freeze(filtros)
		this.filtrosHistoricos = Object.freeze(filtroHistorico.data)
		if (this.existeAlgumFiltroConfigurado && !this.estaApenasVisualizandoOResultado) {
			await this.sendFilters()
		}
	},
	methods: {
		removeDuplicates(array, chaveUnica) {
			const unique = new Map()
			array.forEach((item) => {
				var key = item[chaveUnica]
				key = typeof key === 'string' ? key.toUpperCase().trim() : key // Remove espaços em branco se for string
				if (!unique.has(key)) {
					unique.set(key, item)
				}
			})
			return Array.from(unique.values())
		},
		verificaFiltro() {
			// Verifica se há alguma data selecionada
			const intervaloDataPlantioDiferentes =
				this.filtroConfig.dataPlantioInicio || this.filtroConfig.dataPlantioFim
			const iintervaloDataMedicaoDiferentes =
				this.filtroConfig.dataMedicaoInicio || this.filtroConfig.dataMedicaoFim

			if (
				this.filtroConfig.espacamentos.length ||
				this.filtroConfig.materiaisGeneticos.length ||
				intervaloDataPlantioDiferentes ||
				iintervaloDataMedicaoDiferentes ||
				this.filtroConfig.estratosIds.length ||
				this.filtroConfig.datasMedicao.length ||
				this.filtroConfig.datasPlantio.length ||
				this.filtroConfig.idadesPlantio.length ||
				this.filtroConfig.idadePlantioMin != null ||
				this.filtroConfig.idadePlantioMax != null ||
				this.filtroConfig.especiesIds.length ||
				this.filtroConfig.fazendasIds.length ||
				this.filtroConfig.tiposServicos.length ||
				this.filtroConfig.talhoesIds.length ||
				this.filtroConfig.plantiosIds.length ||
				this.filtroConfig.parcelasIds.length ||
				this.filtroConfig.cidades.length ||
				this.filtroConfig.estados.length ||
				this.filtroConfig.paises.length ||
				this.filtroConfig.manejos.length ||
				this.filtroConfig.ciclos.length ||
				this.filtroConfig.rotacoes.length ||
				this.filtroConfig.variaveis.length ||
				this.filtroConfig.isSingleTrees == true ||
				this.filtroConfig.processamentosOficiais ||
				this.filtroConfig.baseInativa
			) {
				return false
			} else {
				return true
			}
		},

		isIdadePlantioSelected(feature) {
			return (
				!this.filtroConfig.selectedIdadePlantio.length ||
				(this.filtroConfig.selectedIdadePlantio.length &&
					this.filtroConfig.selectedIdadePlantio.indexOf(feature.properties['Data de Plantio']) >
						-1)
			)
		},

		convertToFormattedDates(timestamps) {
			const arrayTimestamps = Array.isArray(timestamps) ? timestamps : [timestamps]
			return arrayTimestamps.map(function (ts) {
				if (ts === null || ts === undefined || ts === '') {
					return null
				}
				var date = new Date(ts)
				var year = date.getFullYear()
				var month = ('0' + (date.getMonth() + 1)).slice(-2) // Adiciona zero se for necessário
				var day = ('0' + date.getDate()).slice(-2) // Adiciona zero se for necessário
				return year + '-' + month + '-' + day
			})
		},

		voltar() {
			if (this.isPrognose) {
				this.$router.push('/prognose')
			} else {
				this.$router.push('/classificacao')
			}
		},

		customFilter(item, queryText) {
			return (
				Object.values(item).toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
				-1
			)
		},

		// Deriva {ini, fim} do menor/maior value numérico de uma lista de idades
		// (objetos {label, value}). Usado na retrocompat de filtros salvos antigos.
		derivaRangeIdade(idades) {
			const nums = (idades || [])
				.map((i) => Number(i?.value))
				.filter((n) => !Number.isNaN(n) && n >= 0)
			if (!nums.length) return { min: null, max: null }
			return { min: Math.min(...nums), max: Math.max(...nums) }
		},

		// Máscara: arredonda a idade para 1 casa decimal ao sair do campo (as idades
		// do acervo têm no máximo 1 casa; evita 3.47 etc.). Vazio permanece vazio.
		arredondaIdade(v) {
			if (v === null || v === undefined || v === '') return null
			const n = Number(v)
			return Number.isNaN(n) ? null : Math.round(n * 10) / 10
		},

		// Range de idade (min/max) -> idadesPlantio: seleciona, entre as idades que
		// EXISTEM (idadesPlantioOrdenadas), as que caem no intervalo (idades do acervo
		// podem ter 1 casa decimal). Mantém o shape {label, value} que a
		// busca/processar/histórico já consomem.
		atualizaIdadesPlantioPorRange() {
			const vMin = this.filtroConfig.idadePlantioMin
			const vMax = this.filtroConfig.idadePlantioMax
			const vazio = (v) => v === null || v === undefined || v === ''
			if (vazio(vMin) && vazio(vMax)) {
				this.filtroConfig.idadesPlantio = []
				return
			}
			const min = vazio(vMin) ? -Infinity : Number(vMin)
			const max = vazio(vMax) ? Infinity : Number(vMax)
			this.filtroConfig.idadesPlantio = this.idadesPlantioOrdenadas.filter((f) => {
				const n = Number(f.value)
				return !Number.isNaN(n) && n >= min && n <= max
			})
		},

		limparFiltros() {
			this.filtroConfig.idadePlantioMin = null
			this.filtroConfig.idadePlantioMax = null
			this.filtroConfig.estratosIds = []
			// '' (e nao 0) para voltar ao mesmo estado vazio do carregamento da tela —
			// o DatePicker espera String e o sendFilters trata vazio como "sem filtro".
			this.filtroConfig.dataMedicaoFim = ''
			this.filtroConfig.dataMedicaoInicio = ''
			this.filtroConfig.dataPlantioInicio = ''
			this.filtroConfig.dataPlantioFim = ''
			this.filtroConfig.datasMedicao = []
			this.filtroConfig.datasPlantio = []
			;((this.filtroConfig.IntervaloDataMedicaoSlider = []),
				(this.filtroConfig.IntervaloDataSlider = []),
				(this.filtroConfig.idadesPlantio = []))
			this.filtroConfig.materiaisGeneticos = []
			this.filtroConfig.especiesIds = []
			this.filtroConfig.fazendasIds = []
			this.filtroConfig.espacamentos = []
			this.filtroConfig.tiposServicos = []
			this.filtroConfig.talhoesIds = []
			this.filtroConfig.plantiosIds = []
			this.filtroConfig.parcelasIds = []
			this.filtroConfig.cidades = []
			this.filtroConfig.estados = []
			this.filtroConfig.paises = []
			this.filtroConfig.manejos = []
			this.filtroConfig.ciclos = []
			this.filtroConfig.rotacoes = []
			this.filtroConfig.variaveis = []
			this.filtroConfig.isSingleTrees = false
			this.filtroConfig.processamentosOficiais = false
			this.filtroConfig.baseInativa = false
			this.loading = false
			this.isProcessAvailable = true
			this.$emit('limpandoFiltro')
		},

		async sendFilters() {
			var datasPlantio = []
			var datasMedicao = []

			// Verifica se há alguma data de plantio selecionada
			if (this.filtroConfig.dataPlantioInicio || this.filtroConfig.dataPlantioFim) {
				datasPlantio = [this.filtroConfig.dataPlantioInicio, this.filtroConfig.dataPlantioFim]

				if (datasPlantio[0] || datasPlantio[1]) {
					if (datasPlantio[0] === '' || datasPlantio[0] === null) {
						//se a data minima for vazia, mas a data maxima for preenchida
						this.filtroConfig.IntervaloDataSlider = [null, new Date(datasPlantio[1]).getTime()]
					} else if (datasPlantio[1] === '' || datasPlantio[1] === null) {
						//se a data maxima for vazia, mas a data minima for preenchida
						this.filtroConfig.IntervaloDataSlider = [new Date(datasPlantio[0]).getTime(), null]
					} else {
						//se as duas datas estiverem preenchidas
						this.filtroConfig.IntervaloDataSlider = [
							new Date(datasPlantio[0]).getTime(),
							new Date(datasPlantio[1]).getTime(),
						]
					}
				}
				//pega a data em formato ISO e converte para o formato YYYY-MM-DD -> sem isso nao pegava todas as parcelas
				datasPlantio = this.convertToFormattedDates(datasPlantio)
			}

			// Verifica se há alguma data de medição selecionada
			if (this.filtroConfig.dataMedicaoInicio || this.filtroConfig.dataMedicaoFim) {
				datasMedicao = [this.filtroConfig.dataMedicaoInicio, this.filtroConfig.dataMedicaoFim]

				if (datasMedicao[0] || datasMedicao[1]) {
					if (datasMedicao[0] === '' || datasMedicao[0] === null) {
						//se a data minima for vazia, mas a data maxima for preenchida
						this.filtroConfig.IntervaloDataMedicaoSlider = [
							null,
							new Date(datasMedicao[1]).getTime(),
						]
					} else if (datasMedicao[1] === '' || datasMedicao[1] === null) {
						//se a data maxima for vazia, mas a data minima for preenchida
						this.filtroConfig.IntervaloDataMedicaoSlider = [
							new Date(datasMedicao[0]).getTime(),
							null,
						]
					} else {
						//se as duas datas estiverem preenchidas
						this.filtroConfig.IntervaloDataMedicaoSlider = [
							new Date(datasMedicao[0]).getTime(),
							new Date(datasMedicao[1]).getTime(),
						]
					}
				}
				//pega a data em formato ISO e converte para o formato YYYY-MM-DD -> sem isso nao pegava todas as parcelas
				datasMedicao = this.convertToFormattedDates(datasMedicao)
			}

			this.fetchAgrupamentos = true
			this.$emit('filtrando', this.fetchAgrupamentos)

			// Verifica se não há NENHUM filtro selecionado
			const nenhumFiltroSelecionado =
				!this.filtroConfig.estratosIds?.length &&
				!this.filtroConfig.idadesPlantio?.length &&
				this.filtroConfig.idadePlantioMin == null &&
				this.filtroConfig.idadePlantioMax == null &&
				!this.filtroConfig.materiaisGeneticos?.length &&
				!this.filtroConfig.especiesIds?.length &&
				!this.filtroConfig.fazendasIds?.length &&
				!this.filtroConfig.espacamentos?.length &&
				!this.filtroConfig.parcelasIds?.length &&
				!this.filtroConfig.talhoesIds?.length &&
				!this.filtroConfig.plantiosIds?.length &&
				!this.filtroConfig.cidades?.length &&
				!this.filtroConfig.estados?.length &&
				!this.filtroConfig.paises?.length &&
				!this.filtroConfig.manejos?.length &&
				!this.filtroConfig.ciclos?.length &&
				!this.filtroConfig.rotacoes?.length &&
				!this.filtroConfig.variaveis?.length &&
				!this.filtroConfig.tiposServicos?.length &&
				!this.filtroConfig.isSingleTrees &&
				!this.filtroConfig.processamentosOficiais &&
				!this.filtroConfig.baseInativa &&
				!datasPlantio?.length &&
				!datasMedicao?.length

			// Verifica quais campos estão visíveis (isActive: true)
			const isFazendaVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'fzda')?.isActive
			const isEstratoVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'esfl')?.isActive
			const isEspacamentoVisible = this.valuesDropdownCheckbox.find(
				(v) => v.key === 'spcmt',
			)?.isActive
			const isMaterialGeneticoVisible = this.valuesDropdownCheckbox.find(
				(v) => v.key === 'matgen',
			)?.isActive
			const isEspecieVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'spce')?.isActive
			const isTalhaoVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'tlho')?.isActive
			const isPlantioVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'ptio')?.isActive
			const isParcelaVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'prcl')?.isActive
			const isCidadeVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'cidade')?.isActive
			const isEstadoVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'estado')?.isActive
			const isPaisVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'pais')?.isActive
			const isManejoVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'manejo')?.isActive
			const isCicloVisible = this.valuesDropdownCheckbox.find((v) => v.key === 'ciclo')?.isActive
			const isRotacaoVisible = this.valuesDropdownCheckbox.find(
				(v) => v.key === 'rotacao',
			)?.isActive
			const isVariaveisVisible = this.valuesDropdownCheckbox.find(
				(v) => v.key === 'variaveisCustomizadas',
			)?.isActive

			// Se não houver NENHUM filtro selecionado, usa todos os valores disponíveis APENAS para campos visíveis
			// Caso contrário, usa apenas os valores selecionados (ou array vazio se não houver seleção naquele campo)
			const estratosIds =
				nenhumFiltroSelecionado && isEstratoVisible
					? this.estratosOrdenados.map((f) => f.id)
					: this.filtroConfig.estratosIds?.map((f) => f.id) || []

			// Idade de plantio agora vai por INTERVALO (min/max, decimais). Vazio = null
			// (sem limite naquele extremo). Não enviamos mais a lista idadesPlantio: as
			// idades do acervo têm casas decimais e o backend (List<int?>) não convertia.
			const vazioNum = (v) => v === null || v === undefined || v === ''
			const idadePlantioMin = vazioNum(this.filtroConfig.idadePlantioMin)
				? null
				: Number(this.filtroConfig.idadePlantioMin)
			const idadePlantioMax = vazioNum(this.filtroConfig.idadePlantioMax)
				? null
				: Number(this.filtroConfig.idadePlantioMax)

			const materiaisGeneticos =
				nenhumFiltroSelecionado && isMaterialGeneticoVisible
					? this.materiaisGeneticosOrdenados.map((f) => f.value)
					: this.filtroConfig.materiaisGeneticos?.map((f) => f.value) || []

			const especiesIds =
				nenhumFiltroSelecionado && isEspecieVisible
					? this.especiesOrdenadas.map((f) => f.id)
					: this.filtroConfig.especiesIds?.map((f) => f.id) || []

			const fazendasIds =
				nenhumFiltroSelecionado && isFazendaVisible
					? this.fazendasOrdenadas.map((f) => f.id)
					: this.filtroConfig.fazendasIds?.map((f) => f.id) || []

			const espacamentos =
				nenhumFiltroSelecionado && isEspacamentoVisible
					? this.espacamentosOrdenados.map((f) => f.value)
					: this.filtroConfig.espacamentos?.map((f) => f.value) || []

			const parcelasIds =
				nenhumFiltroSelecionado && isParcelaVisible
					? this.parcelasOrdenados.map((f) => f.id)
					: this.filtroConfig.parcelasIds?.map((f) => f.id) || []

			const talhoesIds =
				nenhumFiltroSelecionado && isTalhaoVisible
					? this.talhoesOrdenados.map((f) => f.id)
					: this.filtroConfig.talhoesIds?.map((f) => f.id) || []

			const plantiosIds =
				nenhumFiltroSelecionado && isPlantioVisible
					? this.plantiosOrdenados.map((f) => f.id)
					: this.filtroConfig.plantiosIds?.map((f) => f.id) || []

			const cidades =
				nenhumFiltroSelecionado && isCidadeVisible
					? this.cidadesOrdenados.map((f) => f.value)
					: this.filtroConfig.cidades?.map((f) => f.value) || []

			const estados =
				nenhumFiltroSelecionado && isEstadoVisible
					? this.estadosOrdenados.map((f) => f.value)
					: this.filtroConfig.estados?.map((f) => f.value) || []

			const paises =
				nenhumFiltroSelecionado && isPaisVisible
					? this.paisesOrdenados.map((f) => f.value)
					: this.filtroConfig.paises?.map((f) => f.value) || []

			const manejos =
				nenhumFiltroSelecionado && isManejoVisible
					? this.manejosOrdenados.map((f) => f.value)
					: this.filtroConfig.manejos?.map((f) => f.value) || []

			const ciclos =
				nenhumFiltroSelecionado && isCicloVisible
					? this.ciclosOrdenados.map((f) => f.value)
					: this.filtroConfig.ciclos?.map((f) => f.value) || []

			const rotacoes =
				nenhumFiltroSelecionado && isRotacaoVisible
					? this.rotacoesOrdenados.map((f) => f.value)
					: this.filtroConfig.rotacoes?.map((f) => f.value) || []

			const variaveis =
				nenhumFiltroSelecionado && isVariaveisVisible
					? this.variaveisOrdenadas.map((f) => f.value)
					: this.filtroConfig.variaveis?.map((f) => f.value) || []

			// Filtro montado a partir da configuração da tela. É o MESMO objeto
			// usado na busca (filtro-para-prognose) e, no novo fluxo de processar
			// orquestrado pelo back (D), reaproveitado pelo parent para mandar só o
			// filtro ao endpoint processar-prognose (evita trafegar centenas de MB).
			const filtroApi = {
				estratosIds: estratosIds,
				datasMedicao: datasMedicao,
				datasPlantio: datasPlantio,
				idadePlantioMin: idadePlantioMin,
				idadePlantioMax: idadePlantioMax,
				materiaisGeneticos: materiaisGeneticos,
				especiesIds: especiesIds,
				fazendasIds: fazendasIds,
				espacamentos: espacamentos,
				parcelasIds: parcelasIds,
				talhoesIds: talhoesIds,
				plantiosIds: plantiosIds,
				cidades: cidades,
				estados: estados,
				paises: paises,
				manejos: manejos,
				ciclos: ciclos,
				rotacoes: rotacoes,
				variaveis: variaveis,
				tiposServicos: this.filtroConfig.tiposServicos,
				isSingleTrees: this.filtroConfig.isSingleTrees,
				processamentosOficiais: this.filtroConfig.processamentosOficiais,
				baseInativa: this.filtroConfig.baseInativa,
				enableHistoricalData: this.filtroConfig.enableHistoricalData,
			}

			// Disponibiliza o filtro aplicado para o parent (usado no processar por filtro).
			// Sem os campos de gráfico: o processar usa os dados COMPLETOS, não a redução.
			this.$emit('filtroAplicado', filtroApi)

			// Para a busca da 1ª tela, pede a redução IQR (só visual) ao back.
			const filtroBusca = this.variavelGrafico
				? {
						...filtroApi,
						variavelGrafico: this.variavelGrafico,
						maxPontosGrafico: this.maxPontosGrafico,
					}
				: filtroApi

			const request = this.isPrognose ? filterParcelasPrognose : filterParcelas
			const res = await request(filtroBusca)

			if (res.status === 200) {
				this.fetchAgrupamentos = false
				this.$emit('filtrando', this.fetchAgrupamentos)
			}
			this.isProcessAvailable = false
			this.loading = false

			// Resposta da busca reduzida: envelope { pontos, totalPontos, totalParcelas,
			// totalPlantios }. Compat: se vier array puro (sem redução), trata como antes.
			const payload = res.data.result
			const pontos = Array.isArray(payload) ? payload : payload?.pontos || []
			const meta = Array.isArray(payload)
				? null
				: {
						totalPontos: payload?.totalPontos ?? pontos.length,
						totalParcelas: payload?.totalParcelas ?? null,
						totalPlantios: payload?.totalPlantios ?? null,
					}

			this.$emit('filtrar', pontos)
			this.$emit('metaAmostragem', meta)
			this.$emit('buscando', 'Atualizado agora')
		},
		escolhaModelos() {
			this.loading = true
			this.disableBuscar = true
			this.modelagemStatus = false
			this.isProcessAvailable = true
			this.color = 'gray'
			this.$emit('processar')
		},
	},
}
</script>

<style>
.idade-plantio-range {
	margin-bottom: 12px;
}

.idade-plantio-range__label {
	display: block;
	font-size: 12px;
	color: #081f44;
	margin-bottom: 4px;
}

.idade-plantio-range__campos {
	display: flex;
	gap: 8px;
}

.container__filtragem__content {
	position: relative;
	/* display: flex; */
	/* flex-direction: column; */
	justify-content: space-between;
	height: 100%;
	box-sizing: border-box;
}

.container__buttons__tags {
	margin-top: 1rem;
	display: flex;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 1rem;
	padding: 0 0.8rem;
	align-content: center;
}

/* Os botões de filtro são toggles: o estado vem só do `outlined`. O Button pinta
   o outlined com foco como preenchido, então após desmarcar pelo mouse o botão
   continuava parecendo selecionado até perder o foco. Mantém o realce do foco
   via teclado (:focus-visible). */
.container__buttons__tags .ui.button.outlined.trv-primary:focus:not(:focus-visible) {
	background-color: transparent;
	color: rgb(var(--color-primary));
}

.container__buttons {
	display: flex;
	flex-direction: row;
}

.container__campos__filtragem {
	display: block;
	max-height: 50vh;
	overflow: auto;
	top: 1rem;
	bottom: 0;
	padding: 1rem;
	height: 100%;

	gap: 2rem !important;
}

button {
	margin: 0;
}

.container__action__buttons {
	display: grid;
	gap: 1rem;
	width: 100%;
	position: absolute;
	bottom: 0;
	padding: 2rem 1rem;
}

.container__card__custom {
	width: 100%;
	height: 90%;
}

.v-window.v-item-group.theme--light.v-tabs-items {
	display: block;
	max-height: inherit;
	width: 100%;
	box-sizing: border-box;
	/* position: relative;  */
	/* margin-top: 50px; */
}

.container__selecao__campos {
	padding: 0 0.8rem;
	margin-top: 0.5rem;
}

.teste {
	color: 'red' !important;
}
.container-date-picker {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: center;
	width: 100%;
	max-width: 25rem;
	gap: 1rem;
	margin: 0 auto;
}

.date-picker {
	flex: 1;
	min-width: 0;
}

.date-picker .datepicker {
	height: 40px;
}

.date-picker .datepicker i {
	display: flex;
	align-items: center;
	padding: 0 0.5rem;
}

.date-picker .datepicker .ui.input > input {
	height: 100%;
}

.container-selecao-datas {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-bottom: 25px;
}

.container-selecao-datas.first-date {
	margin-top: -10px;
}

.container-selecao-datas.second-date {
	margin-top: -10px;
}
</style>

<style>
.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>
